  document.addEventListener('DOMContentLoaded', () => {
    // Check for touch device
    const isTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
    const cards = document.querySelectorAll('.gpe-card');
    
    if (!isTouch) {
      // Mouse follow effect for non-touch devices only
      cards.forEach(card => {
        card.addEventListener('mousemove', (e) => {
          // Get position relative to the card
          const rect = card.getBoundingClientRect();
          const x = ((e.clientX - rect.left) / rect.width) * 100;
          const y = ((e.clientY - rect.top) / rect.height) * 100;
          
          // Set CSS variable for the radial gradient
          card.style.setProperty('--x', `${x}%`);
          card.style.setProperty('--y', `${y}%`);
        });
      });
    }
    
    // Add Intersection Observer for scroll animations
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.style.opacity = '1';
            observer.unobserve(entry.target);
          }
        });
      }, {
        threshold: 0.1,
        rootMargin: '50px'
      });
      
      cards.forEach(card => {
        observer.observe(card);
      });
    } else {
      // Fallback for browsers that don't support IntersectionObserver
      cards.forEach(card => {
        card.style.opacity = '1';
      });
    }
  });